import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home-four',
  templateUrl: './home-four.component.html',
  styleUrl: './home-four.component.css'
})
export class HomeFourComponent {
  // OWl Slider
  customOptions: OwlOptions = {
    loop: false,
    dots: true,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: "From Cloud Computing to Cybersecurity - We Provide End-to-End IT Innovation Tailored for You.",
      image: "assets/images/slides/slide-1.jpg",
      hasOverlay: false
    },

    {
      title: "Trusted IT Experts Committed to Securing, Optimizing, and Scaling Your Digital Infrastructure.",
      image: "assets/images/slides/slide-2.jpg",
      hasOverlay: true
    },

    {
      title: "With Decades of Expertise, We Deliver Smart, Scalable, and Secure Technology Solutions That Keep You Ahead.",
      image: "assets/images/slides/slide-3.jpg",
      hasOverlay: false
    }

  ];

  // Featured Services
  services = [
    {
      icon: 'bi bi-transparency',
      title: 'Developing Strategy',
      description:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.'
    },
    {
      icon: 'bi bi-tools',
      title: 'Blazing Performance',
      description:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.'
    },
    {
      icon: 'bi bi-rocket-fill',
      title: 'Customer Satisfaction',
      description:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.'
    }
  ];

  //Funfacts
  funFacts =[
    {
      number: 2530,
      desc: "Working Hours",
      displayedNumber: 0
    },
    {
      number: 1000,
      desc: "Photo Capture",
      displayedNumber: 0
    },
    {
      number: 500,
      desc: "Project Completed",
      displayedNumber: 0
    },
    {
      number: 300,
      desc: "Telephonic Talk",
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  //Brand Logos
  brands = [
    { image: 'assets/images/brands/brand-1.png', alt: 'brand-1' },
    { image: 'assets/images/brands/brand-2.png', alt: 'brand-2' },
    { image: 'assets/images/brands/brand-3.png', alt: 'brand-3' },
    { image: 'assets/images/brands/brand-4.png', alt: 'brand-4' },
    { image: 'assets/images/brands/brand-5.png', alt: 'brand-5' },
    { image: 'assets/images/brands/brand-6.png', alt: 'brand-6' }
  ];

  brandCarouselOptions = {
    loop: true,
    margin: 50,
    autoplay: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 3 },
      992: { items: 5 },
      1200: { items: 5 }
    }
  };
    
  //Blogs 
  blogItems = [
    {
      image: 'assets/images/blogs/blog-md-1.jpg',
      alt: '01',
      category: 'Branding',
      title: "It's Like Dating Entertainment",
      date: 'Apr 29, 2025',
      link: '/blog-grid', 
    },
    {
      image: 'assets/images/blogs/blog-md-2.jpg',
      alt: '02',
      category: 'Design',
      title: 'Out of The Ruins',
      date: 'Apr 28, 2025',
      link: '/blog-grid',
    },
    {
      image: 'assets/images/blogs/blog-md-3.jpg',
      alt: '03',
      category: 'Marketing',
      title: 'Woman Lifestyle',
      date: 'Apr 27, 2025',
      link: '/blog-grid',
    },
    {
      image: 'assets/images/blogs/blog-md-4.jpg',
      alt: '04',
      category: 'Education',
      title: 'Photography Techniques',
      date: 'Apr 27, 2025',
      link: '/blog-grid',
    },
  ];

  blogOptions = {
    loop: true,
    margin: 24,
    autoplay: true,
    dots: true,
    nav: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 2 },
      992: { items: 2 },
      1200: { items: 2 },
    },
  };

  //Testimonials
  testimonials = [
    {
      name: 'Komal Helena',
      role: 'Director',
      image: 'assets/images/testimonials/client-1-md.jpg',
      message: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      rating: 5
    },
    {
      name: 'Jazz Abbs',
      role: 'Developer',
      image: 'assets/images/testimonials/client-1-sm.jpg',
      message: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Cum sociis natoque penatibus et magnis.',
      rating: 5
    },
    {
      name: 'Romely',
      role: 'Designer',
      image: 'assets/images/testimonials/client-3-md.jpg',
      message: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.',
      rating: 5
    }
  ];
}
